import { Component, ContentChild, Input, OnInit } from "@angular/core";

@Component({
  selector: "v4-widget-image-caption",
  templateUrl: "./image-caption.component.html",
  styleUrls: ["./image-caption.component.scss"],
})
export class ImageCaptionComponent implements OnInit {
  // @ContentChild(".image-caption_caption") customCaption;
  // @ContentChild(".image-caption_image") customImage;
  @Input() size: "small" | "default" | "large" = "small";
  @Input() img;
  @Input() caption;
  constructor() {}

  ngOnInit() {
    // setTimeout(() => {
    //   console.log("this.customImage: ", this.customImage);
    // }, 3000);
  }
}
